import { FlexCol, OrientedFlexProps } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { cn } from "@design-system/Utilities";
import { type FC, type ReactNode } from "react";
import { useKnowledgeBasePageTranslations } from "../../i18n";

export const KnowledgeBaseHeader: FC<
    {
        title?: string;
        subtitle?: ReactNode;
        noBorder?: boolean;
    } & OrientedFlexProps
> = ({ title, subtitle, noBorder, ...props }) => {
    const { t, keys } = useKnowledgeBasePageTranslations();
    return (
        <FlexCol
            gap={props.gap}
            p={props.p}
            className={cn(
                "bg-secondary rounded-lg",
                !noBorder && "border border-tertiary",
            )}
        >
            <Text align="left" variant="hero6">
                {title ?? t(keys.title)}
            </Text>

            <Text as="p" align="left" className="leading-[24px] max-w-[700px]">
                {subtitle ?? t(keys.subTitle)}
            </Text>
        </FlexCol>
    );
};
